import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { useEngagements, useFeedback } from "./store";
import { getFormattedDate } from "modules/utilities/utility";
import Reaction from "assets/svgs/reaction";
import Regular from "assets/svgs/regular";
import Energy from "assets/svgs/energy";
import GutHealth from "assets/svgs/gut_health";
import HairFall from "assets/svgs/hair_fall";
import HairGrowth from "assets/svgs/hair_growth";
import MoodChanges from "assets/svgs/mood_changes";
import Reasons from "assets/svgs/reasons";
import IrregularityReason from "assets/svgs/irregularity_reason";
import Reactions from "assets/svgs/reactions";
import EmptyAssignment from "assets/svgs/empty_assignment";
import EmptyEngagement from "assets/svgs/empty_engagement";
import SoftBadge from "modules/common/SoftBadge";
import { MessageOutlined } from "@ant-design/icons";

function Engagements({ buttonStyle, buttonText, orderId }) {
  const [show, setShow] = useState(false);

  const { fetchEngagementsData, engagementsData } = useEngagements();
  const { fetchFeedbackData, feedbackData } = useFeedback();
  const { customConsultFeedbackForm, setCustomConsultFeedbackForm } = useState(
    {}
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if(show){
      fetchEngagementsData(orderId);
      fetchFeedbackData(orderId, setCustomConsultFeedbackForm);
    }
  }, [orderId, show]);

  useEffect(() => {
    feedbackData && feedbackData.length && feedbackData.map((feedback) => {});
  }, [engagementsData, feedbackData]);

  const engagementHeader = {
    "Product Reaction Yes/No": <Reaction />,
    "Regular / Irregular": <Regular />,
    Irregular: <IrregularityReason />,
    "Energy 1/5/10": <Energy />,
    "Gut Health 1/5/10": <GutHealth />,
    "Hair Growth 1/5/10": <HairFall />,
    "Hair Fall 1/5/10": <HairGrowth />,
    "Mood -No Change(1), Some Change(5), Improvement(10)": <MoodChanges />,
    "Product Reaction": <Reactions />,
    "Reason for not ordering": <Reasons />,
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        trigger={["hover", "focus"]}
        overlay={
          <Tooltip>
            <span className="fw-bold"> Engagements</span>
          </Tooltip>
        }
      >
        <div onClick={handleShow}>
          <span className="mt-n1 bg-primary text-white d-flex justify-content-center p-2 rounded-circle shadow" id="messageOutlined">
            <MessageOutlined />
          </span>
        </div>
      </OverlayTrigger>
      <Offcanvas
        className="w-50"
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Engagements</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Tabs defaultActiveKey="engagements" id="uncontrolled-tab-example">
            <Tab eventKey="engagements" title="Engagements" className="p-3">
              <div className="shadow rounded-bottom text-black">
                <div
                  style={{ background: "#F9FAFD" }}
                  className="d-flex border rounded-top"
                >
                  <p
                    style={{ flex: 0.6 }}
                    className="text-center m-0 border-end p-2  py-3"
                  >
                    Due Date
                  </p>
                  <p
                    style={{ flex: 0.6 }}
                    className="text-center m-0 border-end p-2  py-3"
                  >
                    Actual Date
                  </p>
                  <p
                    style={{ flex: 0.5 }}
                    className="text-center m-0 border-end p-2  py-3"
                  >
                    Status
                  </p>
                  <p
                    style={{ flex: 0.9 }}
                    className="text-center m-0 border-end p-2  py-3"
                  >
                    Tags
                  </p>
                  <p style={{ flex: 2 }} className="m-0  p-2  py-3">
                    Notes
                  </p>
                </div>
                {Array.isArray(engagementsData) && engagementsData.length ? (
                  engagementsData.map((engagement, index) => {
                    return (
                      <div
                        key={index}
                        className={`d-flex border border-top-0 ${
                          index === engagementsData.length - 1 &&
                          `rounded-bottom`
                        }`}
                      >
                        <p
                          style={{ fontSize: 13, flex: 0.6 }}
                          className="text-center fw-bold m-0 border-end p-2"
                        >
                          {getFormattedDate(engagement.due_date) || "-"}
                        </p>
                        <p
                          style={{ fontSize: 13, flex: 0.6 }}
                          className="text-center fw-bold m-0 border-end p-2"
                        >
                          {getFormattedDate(engagement.actual_date) || "-"}
                        </p>
                        <p
                          style={{ flex: 0.5 }}
                          className="text-center m-0 border-end p-2"
                        >
                          <SoftBadge bg="primary" className="text-uppercase">
                            {engagement.status || "-"}
                          </SoftBadge>
                        </p>
                        <p
                          style={{ flex: 0.9 }}
                          className="text-center m-0 border-end p-2"
                        >
                          <SoftBadge bg="primary" className="text-uppercase">
                            {engagement.tag || "-"}
                          </SoftBadge>
                        </p>
                        <p style={{ flex: 2 }} className="m-0  p-2">
                          {engagement.notes || "-"}
                        </p>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{ background: "#ccc" }}
                    className="w-100 border rounded border-secondary text-white fw-bold p-2 my-2 ps-4"
                  >
                    <EmptyEngagement />{" "}
                    <span className="ms-4">No Engagement data</span>
                  </div>
                )}
              </div>
            </Tab>
            <Tab eventKey="feedback" title="Feedback" className="p-3">
              <div className="shadow rounded-bottom text-black">
                <div
                  style={{ background: "#F9FAFD" }}
                  className="d-flex border rounded-top"
                >
                  <p
                    style={{ minWidth: "7.4rem" }}
                    className="border-end p-2 m-0 text-center"
                  >
                    Engagements
                  </p>
                  {Object.entries(engagementHeader).map(
                    ([tooltip, icon], index) => {
                      return (
                        <div
                          key={index}
                          style={
                            [
                              "Regular / Irregular",
                              "Irregular",
                              "Reason for not ordering",
                              "Product Reaction",
                            ].includes(tooltip)
                              ? { flex: 1.5 }
                              : { flex: 1 }
                          }
                          className={`
                          ${
                            Object.entries(engagementHeader)[index + 1]
                              ? "border-end p-2 m-0 text-center"
                              : "p-2 m-0 text-center"
                          }`}
                        >
                          <OverlayTrigger
                            overlay={
                              <Tooltip
                                style={{
                                  position: "fixed",
                                  zIndex: 999999,
                                  fontSize: 12,
                                }}
                                className="fw-bold"
                              >
                                <span className="p-2">{tooltip}</span>
                              </Tooltip>
                            }
                          >
                            <div>{icon}</div>
                          </OverlayTrigger>
                        </div>
                      );
                    }
                  )}
                </div>
                {Array.isArray(feedbackData) && feedbackData.length ? (
                  feedbackData.map((feedback, rowIndex) => {
                    const {
                      tag,
                      any_product_reaction,
                      customer_adherence,
                      adherence_reason,
                      energy,
                      gut_health,
                      hair_growth,
                      hair_loss,
                      mood,
                      product_reaction,
                      not_ordering_reason,
                    } = feedback;
                    const feedbackValue = {
                      tag,
                      any_product_reaction,
                      customer_adherence,
                      adherence_reason,
                      energy,
                      gut_health,
                      hair_growth,
                      hair_loss,
                      mood,
                      product_reaction,
                      not_ordering_reason,
                    };

                    return (
                      <div
                        className={`d-flex border border-top-0 ${
                          rowIndex === feedbackData.length - 1 &&
                          `rounded-bottom`
                        }`}
                      >
                        {Object.entries(feedbackValue).map(
                          ([key, value], index) => (
                            <p
                              key={key}
                              style={
                                key === "tag"
                                  ? { minWidth: "7.4rem" }
                                  : [
                                      "customer_adherence",
                                      "adherence_reason",
                                      "not_ordering_reason",
                                      "product_reaction",
                                    ].includes(key)
                                  ? { flex: 1.5 }
                                  : { flex: 1 }
                              }
                              className={`flex-1 ${
                                index ===
                                Object.entries(feedbackValue).length - 1
                                  ? "border-end-0"
                                  : "border-end"
                              } p-2 m-0 text-center`}
                            >
                              {value || "N/A"}
                            </p>
                          )
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{ background: "#ccc" }}
                    className="w-100 border rounded border-secondary text-white fw-bold p-2 my-2 ps-4"
                  >
                    <EmptyAssignment />{" "}
                    <span className="ms-4">No feedback data</span>
                  </div>
                )}
              </div>
            </Tab>
          </Tabs>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Engagements;
